import React from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import Select from 'orionsoft-parts/lib/components/fields/Select'
import {Field, WithValue} from 'simple-react-form'
import ArrayComponent from 'App/components/fields/ArrayComponent'
import ValidationField from './ValidationField'

export default function ReleaseOrderValidations(props) {
  const {releaseOrderValidations} = useQuery({
    query: gql`
      query {
        releaseOrderValidations {
          label
          value
        }
      }
    `
  })

  if (!releaseOrderValidations) return null

  return (
    <Field
      fieldName="rules"
      label="Reglas"
      value={props.value}
      type={ArrayComponent}
      onChange={props.onChange}>
      <Field fieldName="validations" label="Condiciones" type={ArrayComponent}>
        <WithValue>
          {({option}) => (
            <>
              <Field
                label="Tipo de opción"
                fieldName="option"
                type={Select}
                description="Corresponde a la variable a considerar para la validación de la condición"
                options={releaseOrderValidations}
              />
              <ValidationField option={option} />
            </>
          )}
        </WithValue>
      </Field>
    </Field>
  )
}
